import { provideAnimations } from '@angular/platform-browser/animations';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { ApplicationStore } from '@ffx/app-store';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { bearerTokenInterceptor } from './interceptors/bearer-token.inteceptor';
import { environment } from '@ffx/env';
import { provideFeatureFlags } from '@ffx/feature-flags';
import { provideEventPlugins } from '@taiga-ui/event-plugins';

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(appRoutes),
        provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
        provideFirestore(() => getFirestore()),
        ApplicationStore,
        provideEventPlugins(),
        provideAuth(() => getAuth()),
        provideHttpClient(withInterceptors([bearerTokenInterceptor])),
        provideFeatureFlags({
            environmentId: environment.environmentId,
            projectId: 'a4845433-5caa-4363-85c3-f611938007cd'
        })
    ]
};
